var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"other-method-tab"},_vm._l((_vm.otherPsps),function(other){return _c('CardOther',{key:other.id,attrs:{"other":other}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }